import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3260_63448)",
			children: /* @__PURE__ */ _jsx("path", { d: "M15.5566 5.56969C15.5566 5.93031 15.2767 6.2108 14.9167 6.2108C14.5568 6.2108 14.2769 5.93031 14.2369 5.56969V2.46341C14.2369 2.10279 13.9569 1.8223 13.597 1.8223H3.79917L8.79808 3.94599C9.71787 4.30662 10.3977 5.3885 10.3977 6.35017V18.6916H13.637C13.9969 18.6916 14.2769 18.4111 14.2769 18.0505V14.9443C14.2769 14.5836 14.5568 14.3031 14.9167 14.3031C15.2767 14.3031 15.5566 14.5836 15.5566 14.9443V18.0505C15.5566 19.1324 14.6768 20.0139 13.597 20.0139H10.3577V21.9373C10.3577 22.4983 10.1178 22.9791 9.71787 23.2596C9.47793 23.4199 9.23798 23.5 8.95804 23.5C8.75808 23.5 8.51814 23.4199 8.27819 23.3397L1.59965 20.4547C0.679851 20.0941 0 19.0122 0 18.0505V2.46341C0 1.38153 0.879808 0.5 1.95957 0.5H13.597C14.6768 0.5 15.5566 1.38153 15.5566 2.46341V5.56969ZM23.7948 9.79617C24.0747 10.0366 24.0747 10.4774 23.7548 10.7578L19.8757 14.6446C19.7557 14.7648 19.5957 14.8449 19.4358 14.8449C19.2758 14.8449 19.1158 14.7648 18.9958 14.6446C18.7559 14.4042 18.7559 13.9634 18.9958 13.723L21.7952 10.9181H13.637C13.2771 10.9181 12.9972 10.6376 12.9972 10.277C12.9972 9.91638 13.2771 9.63589 13.637 9.63589H21.7952L18.9958 6.83101C18.7559 6.59059 18.7559 6.14983 18.9958 5.90941C19.2358 5.66899 19.6757 5.66899 19.9156 5.90941L23.7948 9.79617ZM2.52527 2.75922C2.41992 2.71342 2.30626 2.68979 2.19138 2.68979C1.72884 2.68979 1.35388 3.06475 1.35388 3.52729V17.2005C1.35388 18.2035 1.9504 19.1104 2.87139 19.5076L7.83084 21.6465C7.93557 21.6917 8.04844 21.715 8.1625 21.715C8.62504 21.715 9 21.34 9 20.8775V7.22131C9 6.22096 8.40658 5.31592 7.48917 4.91711L2.52527 2.75922Z" })
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3260_63448",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
